module.exports = __webpack_public_path__ + "images/search@1x.png?b79b6629";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/search@1x.png
// module id = 695
// module chunks = 7